import {
	Button,
	CircularProgress,
	Grid,
	InputLabel,
	Snackbar,
	TextField,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert/Alert";
import type React from "react";
import { type SyntheticEvent, useEffect, useState } from "react";
import { useFormsContext } from "../context/formsContext";
import { useGetSelectedInstanceStatus } from "../hooks";
import { useToken } from "@dexteel/mesf-core";

export const EditInstanceSubmitAndApprove: React.FC = () => {
	const {
		state: { formComment, submitInitials, approveInitials, formInstanceStatus },
		actions: { setformComment, setApproveInitials, setSubmitInitials },
	} = useFormsContext();

	const { hasPermission } = useToken();

	const [canApprove, setCanApprove] = useState<boolean>(
		hasPermission("FORMS.ApproveFormInstance" as any),
	);

	const getStatus = useGetSelectedInstanceStatus();

	const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);
	const [aprroveSuccess, setApproveSuccess] = useState<boolean>(false);
	const [unaprroveSuccess, setUnapproveSuccess] = useState<boolean>(false);
	const [saveDataError, setSaveDataError] = useState<boolean>(false);

	const handleClose = (event?: SyntheticEvent, reason?: string) => {
		setSubmitSuccess(false);
		setApproveSuccess(false);
		setUnapproveSuccess(false);
		setSaveDataError(false);
	};

	const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.preventDefault();
		setformComment(event.target.value);
	};

	const handleInitialsChangeSubmit = (
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		event.preventDefault();
		setSubmitInitials(event.target.value);
	};

	const handleInitialsChangeApprove = (
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		event.preventDefault();
		setApproveInitials(event.target.value);
	};

	useEffect(() => {}, [formInstanceStatus]);

	return (
		<>
			<hr />
			<Grid container spacing={2}>
				<Grid item container xs={8} md={8}>
					<TextField
						disabled={formInstanceStatus === "S" || formInstanceStatus === "A"}
						label="Comments"
						variant="outlined"
						fullWidth
						placeholder="Enter the Comments Here"
						onChange={handleCommentChange}
						value={formComment}
					/>
				</Grid>
				<Grid item container xs={2} md={2}>
					<TextField
						disabled={formInstanceStatus === "S" || formInstanceStatus === "A"}
						label="Submit Intials"
						variant="outlined"
						value={submitInitials}
						onChange={handleInitialsChangeSubmit}
						fullWidth
						style={{ marginBottom: "5px" }}
					/>
				</Grid>
				<Grid item container xs={2} md={2}>
					{(formInstanceStatus === "A" || formInstanceStatus === "S") && (
						<TextField
							disabled={formInstanceStatus === "A" || !canApprove}
							id="outlined-error"
							label="Approval Intials"
							variant="outlined"
							value={approveInitials}
							onChange={handleInitialsChangeApprove}
							fullWidth
							style={{ marginBottom: "5px" }}
						/>
					)}
				</Grid>
			</Grid>

			<Snackbar
				open={submitSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
			>
				<Alert severity="success" onClose={handleClose}>
					Form sent correctly!
				</Alert>
			</Snackbar>
			<Snackbar
				open={aprroveSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
			>
				<Alert severity="success" onClose={handleClose}>
					Form Approved correctly!
				</Alert>
			</Snackbar>
			<Snackbar
				open={unaprroveSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
			>
				<Alert severity="success" onClose={handleClose}>
					Form (Un)Approved correctly!
				</Alert>
			</Snackbar>

			<Snackbar
				open={saveDataError}
				autoHideDuration={3000}
				onClose={handleClose}
			>
				<Alert severity="error" onClose={handleClose}>
					Error when trying to save data in the database!
				</Alert>
			</Snackbar>
		</>
	);
};
